import {Questionary} from './questionary'

export interface XmlTagScope {
	questionary: Questionary,
	respectUndefined?: boolean
}

export interface XmlTagInfo {
	tag: string;
	attributes: { [name:string]:string };
	children: any[], // Can be XmlTagInfo or parsed Object (Variable, Quota, ...)
	value?: string,
	scope?: XmlTagScope
}

export class XmlTagProvider {

	regexpCache: {[selector:string]: RegExp} = {};
	tags: { [key:string] : (data:XmlTagInfo) => any };

	constructor(tags: { [xpath:string]: { (node: XmlTagInfo): any } }) {
		this.tags = tags;
	}

	get(path: string[]): (data:any) => any {
		const name = path[path.length - 1];
		const handler = this.tags[name];

		if(!handler){
			for (let selector in this.tags) {
				if(this.tags.hasOwnProperty(selector) && this.matchSelector(path, selector)){
					return this.tags[selector];
				}
			}
		}
		return handler;
	}

	matchSelector(currentPath: string[], selector: string) {
		const r = (this.regexpCache['__' + selector] || (this.regexpCache['__' + selector] = this.selectorToRegExp(selector)));
		return r.test('root/' + currentPath.join('/'));
	}

	selectorToRegExp(selector: string): RegExp {
		if(selector[0] !== '/'){
			selector = '//' + selector;
		}

		const r = '^root' + selector
				.replace(/\/\//g, '(/.*/|/)')
				.replace(/\//g, '\\/') + '$';

		return new RegExp(r);
	}
}